import {LadingStatus} from "@/enums/status/lading";

export enum LadingCustomerStatus {
    DiPhat = 1,
    PhatThanhCong = 2,
    PhatKhongThanhCong = 3,
    ChoLayHang = 4,
    LayHangThanhCong = 5,
    DuyetHoan = 6,
    DangHoan = 7,
    HoanThanhCong = 8,
    Reject = -1
}